import { createUploadLink } from 'apollo-upload-client';
import type { ApolloLink } from '@apollo/client';

export const getUploadLink = ({ uri }: { uri: string }) =>
    createUploadLink({ uri, credentials: 'include' }) as unknown as ApolloLink;
